import { render, staticRenderFns } from "./DialogSalvar.vue?vue&type=template&id=1898b380"
import script from "./DialogSalvar.vue?vue&type=script&lang=js"
export * from "./DialogSalvar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports